// extracted by mini-css-extract-plugin
module.exports = {"section":"HotBid_section__IdsLk","wrapper":"HotBid_wrapper__qgG3x","title":"HotBid_title__SGuEO","inner":"HotBid_inner__1JF_I","card":"HotBid_card__1uBQS"};